<template>
  <div class="neo-footer">
    <div class="neo-container">
      <div class="neo-footer__content">
        <p>{{ new Date().getFullYear() }} Neo Inc. All Rights Reserved.</p>
        <div>
          <div class="links">
            <router-link to="/terms-of-service">Terms of service</router-link>
            <router-link to="/privacy-policy">Privacy policy</router-link>
          </div>
          <ul v-if="showSocials">
            <li v-for="(social, i) in socials" :key="i">
              <a :href="social.link" target="_blank">
                <img :src="getWebsiteImage(`${social.image}.svg`)" alt="T" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NeoFooter",
  data() {
    return {
      showSocials: false,
      socials: [
        {
          image: "twitter",
          link: "#",
        },
        {
          image: "instagram",
          link: "#",
        },
        {
          image: "facebook",
          link: "#",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.neo-footer {
  padding: 40px 0;
  background: #121212;
}

.neo-footer__content {
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    color: #ffffff;
    font-size: 1rem;
  }

  > div {
    display: flex;
    align-items: center;
  }
  .links {
    a {
      color: #fff;
      margin-right: 15px;
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;

    li {
      color: #ffffff;

      &:not(:last-child) {
        margin-right: 20px;
      }

      a {
        display: flex;
        align-items: center;
      }
      img {
        height: 20px;
      }
    }
  }
}

@media (max-width: 600px) {
  .neo-footer__content {
    flex-direction: column;

    > div {
      margin-top: 20px;
    }
  }
}
</style>
